import React from 'react';
import cx from 'classnames';

import DentalButton from 'components/Buttons/DentalButton/DentalButton';
import useIsLoadedInsideIframe from 'hooks/useIsLoadedInsideIframe';

import styles from './NavigationController.module.scss';

interface IProps {
  isDisabledSubmit: boolean;
  title: string;
  isLoading?: boolean;
  onClickBack: () => void;
  onClickNext: () => void;
  hideBack?: boolean;
  isTimeSelection?: boolean;
  isDocked?: boolean;
}

const NavigationController = ({
  title,
  isDisabledSubmit,
  onClickBack,
  onClickNext,
  isLoading = false,
  hideBack = false,
  isTimeSelection = false,
  isDocked = false,
}: IProps) => {
  const isLoadedInsideIframe = useIsLoadedInsideIframe();

  return (
    <div
      className={cx(styles['navigation-container'], {
        [styles['navigation-container-iframe']]: isLoadedInsideIframe,
        [styles['navigation-container-time-selection']]: isTimeSelection,
        [styles['navigation-container-review']]: isDocked,
        [styles['navigation-container-docked']]: isDocked && !isLoadedInsideIframe,
      })}
    >
      {!hideBack && (
        <DentalButton variant="outlined" onClick={onClickBack}>
          Back
        </DentalButton>
      )}
      <DentalButton
        variant="contained"
        disabled={isDisabledSubmit}
        onClick={onClickNext}
        isLoading={isLoading}
      >
        {title}
      </DentalButton>
    </div>
  );
};

export default NavigationController;
